import dayjs from "dayjs";
export default {
  timeFormat(timestamp) {
    if (timestamp.toString().length <= 10) {
      timestamp *= 1000;
    }
    return dayjs(timestamp).format("MM-DD HH:mm");
  },
  getNowMonth(date) {
    return dayjs(date).format("YYYY-MM");
  },
  inBottom() {
    return $(document).scrollTop() >= $(document).height() - $(window).height();
  },
  inTop() {
    return $(document).scrollTop() <= 20;
  },
  addDays(dayNumber) {
    return dayjs()
      .add(8, "hour")
      .add(dayNumber, "day")
      .format("YYYY-MM-DD");
  }
};
